import "moment/min/locales";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IAppState } from "../../redux/types";
import languages, { defaultLang } from "../../utils/Languages";

const LanguagesSelect = ({
  onChange,
}: {
  onChange?: (selectedLag: string) => void;
}): JSX.Element => {
  const { language } = useSelector((state: IAppState) => state.userProfile);
  const [currentLanguage, setcurrentLanguage] = useState(
    language === undefined ? defaultLang.local : language
  );

  useEffect(() => {
    if (language !== currentLanguage && language !== undefined) {
      setcurrentLanguage(language);
    }
  }, [language, currentLanguage]);

  return (
    <div className="flex-column lang-select">
      {languages.map((el) => (
        <div
          style={{ margin: "2px" }}
          className={`truncated-text ${
            el.local === language ? "selected-item " : ""
          }`}
          onClick={() => onChange(el.local)}
          key={el.local + el.code}
          id={"langOpt" + el.code}
        >
          {el.code !== "he" ? (
            <>
              {el.label} {el.labelEng}
            </>
          ) : (
            <>
              <span dir="rtl">{el.label}</span> {el.labelEng}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default React.memo(LanguagesSelect);
